import { api, apiEndPoints } from "../../../../api";
import { showSnackbar } from "../../../../components/snackbar/actions";
import { snackbarTypes } from "../../../../constants";

const namespace = "containers/labels";

export const SET_LABEL_LIST = `${namespace}/SET_LABEL_LIST`;
export const SET_LABEL_FILTER = `${namespace}/SET_LABEL_FILTER`;

export const setLabelList = (payload) => ({
  type: SET_LABEL_LIST,
  payload,
});

export const setLabelFilter = (payload) => ({
  type: SET_LABEL_FILTER,
  payload,
});

export const addLabel = (payload) => async (dispatch) => {
  try {
    const response = await api.post(apiEndPoints.createLabel, payload);
    const { data: { is_success, message } = {} } = response;
    if (is_success) {
      dispatch(
        showSnackbar({
          message: message,
          type: snackbarTypes.SUCCESS,
        })
      );
      return true;
    }
    dispatch(
      showSnackbar({
        message: "Label not added, Please try again!",
        type: snackbarTypes.ERROR,
      })
    );
    return false;
  } catch (error) {
    return false;
  }
};

export const getLabelList = (params) => async (dispatch) => {
  try {
    const response = await api.get(apiEndPoints.getLabels, {
      params: { params },
    });
    const { data, data: { is_success } = {} } = response;
    if (is_success) {
      dispatch(setLabelList(data))
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const getLabelData = (id) => async (dispatch) => {
  try {
    const response = await api.get(apiEndPoints.getLabel(id));
    const { data } = response;
    if (data.is_success) {
      return data;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const editLabel = (payload, id) => async (dispatch) => {
  try {
    const response = await api.put(apiEndPoints.updateLabel(id), payload);
    const { data: { is_success, message } = {} } = response;
    if (is_success) {
      dispatch(
        showSnackbar({
          message: message,
          type: snackbarTypes.SUCCESS,
        })
      );
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const deleteLabelData = (id) => async (dispatch) => {
  try {
    const response = await api.delete(apiEndPoints.deleteLabel(id));
    const { data: { is_success, message } = {} } = response;
    if (is_success) {
      dispatch(
        showSnackbar({
          message: message,
          type: snackbarTypes.SUCCESS,
        })
      );
      return true;
    }
    dispatch(
      showSnackbar({
        message: message,
        type: snackbarTypes.ERROR,
      })
    );
    return false;
  } catch (error) {
    return false;
  }
};
